import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HTMLParser from "html-react-parser";
import "./Description.scss";
import { Parking, Garden, Size, CouncilTax } from "../../../icons/icons";

const Description = (props) => {
  const {
    description,
    ownerslove,
    noticed,
    search_type,
    accommodation,
    size,
    unit,
    extra,
    parking,
    situation,
  } = props;
  const searchTypeContent = {
    sales: { data: ownerslove, title: "The Owners Love" },
  };
  const { data, title } = searchTypeContent[search_type] || {};

  const formatSize = (size, unit) => {
    if (typeof size === "number") {
      return `${size.toLocaleString()} ${unit}`;
    }
    if (size === "N/A") {
      return "";
    }
    return "";
  };

  const unitAbbreviations = { squareMetres: "SQM", squareFeet: "SQ.FT" };
  const Unit =
    unit && unitAbbreviations[unit]
      ? unitAbbreviations[unit]
      : search_type === "lettings"
        ? "SQM"
        : "SQ.FT";

  const formatParkingType = (types) => {
    if (!Array.isArray(types)) return "";

    return types
      .map((type) => {
        // Convert camel case to space-separated words with hyphens
        const spacedType = type?.replace(/([a-z])([A-Z])/g, "$1-$2");
        // Capitalize each word
        return spacedType
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      })
      .join(", ");
  };
  const formattedParking = parking?.[0] ? formatParkingType([parking[0]]) : "";

  const situationList = !situation
    ? []
    : Array.isArray(situation)
      ? situation
        .filter((item) => typeof item === "string")
        .map((item) => item.toLowerCase())
      : typeof situation === "string"
        ? situation.toLowerCase().split(/,|\s+/).filter(Boolean)
        : [];

  // const situationList = Array.isArray(situation)
  //     ? situation.map(item => item?.toLowerCase())
  //     : typeof situation === "string"
  //         ? situation.toLowerCase().split(/,|\s+/)
  //         : [];

  const formatOwnersLove = (text = "") => {
    if (typeof text !== "string") return [];

    return (
      text
        // normalise line breaks
        .replace(/\r/g, "\n")

        // normalise smart quotes
        .replace(/[“”]/g, '"')
        .replace(/[‘’]/g, "'")

        // split by new line
        .split("\n")

        // clean wrapping quotes only
        .map((item) => item?.trim().replace(/^"|"$|^'|'$/g, ""))

        // remove empty values
        .filter(Boolean)
    );
  };
  return (
    <div className="property-description-wrap">
      <Container>
        <Row>
          {/* LEFT SIDE */}
          <Col lg={6} xxl={7}>
            {description && (
              <div className="description">
                <h5 className="sec-title">Description</h5>
                <div className="desc">{HTMLParser(description)}</div>
              </div>
            )}

            {/* ✅ Amenities moved here */}
            <div className="amenities mt-4">
              <h5 className="sec-title">Amenities</h5>
              <ul className="amenities-list">
                {parking && (
                  <li className="parking">
                    <Parking />
                    <div className="list-data">
                      <h6>Parking</h6>
                      <p>{formattedParking}</p>
                    </div>
                  </li>
                )}

                {situation && (
                  <li className="situation">
                    <Garden />
                    <div className="list-data">
                      <h6>Garden</h6>
                      <p>{situationList.some(item => item.toLowerCase().includes("garden")) ? "Yes" : "No"}</p>
                    </div>
                  </li>
                )}

                {size && (
                  <li className="size">
                    <Size />
                    <div className="list-data">
                      <h6>Size</h6>
                      <p>{formatSize(size, Unit)}</p>
                    </div>
                  </li>
                )}

                {extra?.councilTax && (
                  <li className="size">
                    <CouncilTax />
                    <div className="list-data">
                      <h6>Council tax</h6>
                      <p>Band {extra?.councilTax}</p>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          {ownerslove ? (
            <Col lg={6} xxl={7} className="owners-love-section">

              <div className="owners-love">
                <h5 className="sec-title">{title}</h5>
                <ul className="comment-list">
                  {formatOwnersLove(data).map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>

            </Col>
          ) : (
            <Col lg={6} xxl={7} className="key-feature">
              <h5 className="sec-title">Key Features</h5>
              <div className="list-wrap d-md-flex">
                {(accommodation || props?.accommodation) && Array.isArray(accommodation || props?.accommodation) ? (
                  <ul className="desc-list">
                    {(accommodation || props?.accommodation).map((summary, index) => (
                      <li key={index}>{HTMLParser(summary.replace(/^•\s*/, ""))}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </div>
            </Col>
          )}

        </Row>
      </Container>
    </div>
  );
};

export default Description;
